import {parseNumber} from '../../../utils/numerals/parseNumber';
import {timestampToQuater} from '../../../utils/numerals/timestampToQuater';

export const iterateRanges = ( chooser, query ) => {
	Array.from( chooser.querySelectorAll( 'div.range' ) ).forEach( ( it ) => {
		if ( it.parentNode.classList.contains( 'disabled' ) )
		{
			return;
		}

		const name = it.dataset.name;
		const inputMin = it.querySelector( '[name="' + name + '[user_min]"]' );
		const inputMax = it.querySelector( '[name="' + name + '[user_max]"]' );
		const isFloat = it.querySelector( 'ul.inputs' ).dataset.decimalPlaces > 0 ? true : false;
		const min = parseFloat( parseNumber( it.dataset.min, isFloat ) );
		const userMin = parseFloat( parseNumber( inputMin.value.replace( / /g, '' ).replace( ',', '.' ), isFloat, true ) );
		const max = parseFloat( parseNumber( it.dataset.max, isFloat ) );
		const userMax = parseFloat( parseNumber( inputMax.value.replace( / /g, '' ).replace( ',', '.' ), isFloat ) );
		let values = '';

		if ( min !== userMin )
		{
			if ( query.latestChanged === '' && userMin > min )
			{
				inputMin.classList.add( 'user-changed' );
			}
			
			if ( inputMin.classList.contains( 'user-changed' ) )
			{
				query.userChanged += `,${name}-min`;
				values += it.parentNode.dataset.for === 'deadline' ? timestampToQuater( userMin, true ) : userMin;
			}
		}

		values += '-';

		if ( max !== userMax )
		{
			if ( query.latestChanged === '' && userMax < max )
			{
				inputMax.classList.add( 'user-changed' );
			}
			
			if ( inputMax.classList.contains( 'user-changed' ) )
			{
				query.userChanged += `,${name}-max`;
				values += it.parentNode.dataset.for === 'deadline' ? timestampToQuater( userMax, true ) : userMax;
			}
		}

		if ( values === '-' )
		{
			values = '';
		}
		
		if ( values != '' )
		{
			if ( query.search != '' )
			{
				query.search += '&';
			}
			
			query.search += name + '=' + values;
		}
	} );
};